import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import { Banner } from '../../index';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "banner-web-mobile-multi-format"
    }}>{`Banner (Web, Mobile, Multi-Format)`}</h1>
    <h2 {...{
      "id": "regular-web"
    }}>{`Regular (Web)`}</h2>
    <p>{`Classic display banners in many sizes: 160x600, 300x250, 300x500, 728x90 and 900x250.`}</p>
    <Playground __position={0} __code={'<Banner zoneId=\"2921652\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Banner,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Banner zoneId="2921652" mdxType="Banner" />
    </Playground>
    <h2 {...{
      "id": "mobile"
    }}>{`Mobile`}</h2>
    <p>{`Classic display banners in sizes optimized for mobile: 300x100 and 300x250.`}</p>
    <Playground __position={1} __code={'<Banner zoneId=\"4295128\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Banner,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Banner zoneId="4295128" mdxType="Banner" />
    </Playground>
    <h2 {...{
      "id": "multi-format"
    }}>{`Multi-Format`}</h2>
    <p>{`With Multi-Format you can add multiple zones of different ad formats to this single zone. Either by stacking them in a
grid layout or by having them compete against each other for maximum revenue.`}</p>
    <Playground __position={2} __code={'<Banner zoneId=\"4282786\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Banner,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Banner zoneId="4282786" mdxType="Banner" />
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={Banner} mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      